import { Dispatch, SetStateAction } from "react";
import Button from "../Button/Button";
import Modal from "../Modal/Modal";

import styles from "./ConfirmationDialog.module.css";

type ConfirmationDialogProps = {
  title?: string;
  info?: string;
  submitText?: string;
  submitIcon?: string;
  onSubmit: () => void;
  onCancel?: () => void;
  hideCancelButton?: boolean;
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
};

function ConfirmationDialog({
  title,
  info,
  submitIcon,
  submitText,
  onSubmit,
  onCancel,
  hideCancelButton,
  visible,
  setVisible,
}: ConfirmationDialogProps) {
  const closeDialog = () => {
    setVisible(false);
  };

  return (
    <Modal onDismiss={closeDialog} visible={visible}>
      <div className={styles["confirmation-dialog"]}>
        <div className={styles["confirmation-dialog-form"]}>
          <div className={styles["confirmation-dialog-body"]}>
            {title && <h2>{title}</h2>}
            {info && <p>{info}</p>}
          </div>
          <div className={styles["confirmation-dialog-footer"]}>
            <div>
              {!hideCancelButton && (
                <Button
                  variant="ghost"
                  text="Cancel"
                  onClick={() => {
                    setVisible(false);
                    onCancel?.();
                  }}
                />
              )}
            </div>
            <Button
              variant="secondary"
              text={submitText}
              icon={submitIcon}
              onClick={() => {
                setVisible(false);
                onSubmit();
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default ConfirmationDialog;
